export default __webpack_public_path__ + "static/media/about_1.85a3e30a.jpg";